import React from 'react';
import { Route } from 'react-router-dom';
import Configuration from './configuration/Configuration';
import CustomRouteLayout from './questions/customRouteLayout'

export default [
    <Route exact path="/configuration" component={Configuration} />,
    <Route
                exact
                path="/custom"
                component={props => <CustomRouteLayout {...props} />}
            />,
];
